// src/pages/league-dashboard/salary-contract/components/SaveProgressModal.js
//
// Extracted from inline definition in SalaryContractSettings.js per
// Tier 2 #5 commit 5a (refactor only — no behavior change).
import React from 'react';
import { Loader } from 'lucide-react';
import { dynastyTheme } from '../../../../services/colorService';

// Progress Modal Component
const SaveProgressModal = ({ isOpen, progress, message, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className={`${dynastyTheme.components.card.base} p-6 max-w-md w-full mx-4`}>
        <h3 className={`${dynastyTheme.components.heading.h3} mb-4`}>
          Saving Player Prices
        </h3>

        <div className="mb-4">
          <div className="flex items-center justify-between mb-2">
            <span className={dynastyTheme.classes.text.neutralLight}>Progress</span>
            <span className={dynastyTheme.classes.text.primary}>{progress}%</span>
          </div>
          <div className="w-full bg-neutral-700 rounded-full h-3">
            <div
              className="bg-yellow-400 h-3 rounded-full transition-all duration-300"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>

        {message && (
          <p className={`${dynastyTheme.classes.text.neutralLight} text-sm mb-4`}>
            {message}
          </p>
        )}

        <div className="flex items-center justify-center">
          <Loader className="w-6 h-6 animate-spin text-yellow-400" />
          <span className={`ml-2 ${dynastyTheme.classes.text.white}`}>
            Processing...
          </span>
        </div>

        {progress === 100 && (
          <button
            onClick={onClose}
            className={`mt-4 w-full ${dynastyTheme.utils.getComponent('button', 'primary', 'md')}`}
          >
            Continue
          </button>
        )}
      </div>
    </div>
  );
};

export default SaveProgressModal;
